import { iso } from "newtype-ts";
import { pipe } from "fp-ts/function";
import * as Id from "fp-ts/Identity";
export const pack = (x) => iso().wrap(x);
export const unpack = (x) => iso().unwrap(x);
export function overF(F) {
    return (f) => (x) => pipe(x, unpack, f, y => F.map(y, (pack)));
}
export const over = overF(Id.Functor);
